module.exports = __webpack_public_path__ + "media/images/icons/email-092dfbc71fe9224838dd49d4ba1372c2.svg";